import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { fetchPlayerById } from '../../../../api/index.js';
import { CircularProgress, Typography } from '@mui/material';
import FormPlayer from '../create/FormPlayer.js';
import useFetch from '../../../../v2/hooks/useFetch.js';

const EditPlayer = () => {

    const { id } = useParams()

    const { data, isLoading, error, fetchData } = useFetch(fetchPlayerById, [id]);

    useEffect(() => {
        if(!id)
            return

        fetchData()

    }, [id])

    useEffect(() => {

    }, [data])

    useEffect(() => {

        console.log("Error", error)

    }, [error])


    if(isLoading)
        return <CircularProgress/>
    
    if(!data)
        return <Typography sx={{m : 3}}>Aucun joueur trouvé</Typography>

    return <FormPlayer player={data} />

}

export default EditPlayer